(function () {
  'use strict';
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const primary = ['book-lovers-bookmarks','book-lovers-book-sleeves','book-lovers-book-charms','book-lovers-jewelry','book-lovers-bookish-pins','book-lovers-bookish-totes'];
  const titles = {'book-lovers-bookmarks':'Bookmarks','book-lovers-book-sleeves':'Book sleeves','book-lovers-book-charms':'Book charms','book-lovers-jewelry':'Jewelry','book-lovers-bookish-pins':'Pins & brooches','book-lovers-bookish-totes':'Bookish totes'};
  let options = null;
  let selected = null;
  const handleOf = product => product.handle || String(product.url || '').split('?')[0].split('/').filter(Boolean).pop();
  const imageOf = product => product.image || product.images && product.images[0] && (product.images[0].url || product.images[0]);
  const choice = () => options && options.data.moods.find(mood => mood.id === selected) || null;
  const storageKey = () => options.data.personalization.storageKey;
  function setChoice(id) {
    selected = options.data.moods.some(mood => mood.id === id) ? id : null;
    try { if (selected) sessionStorage.setItem(storageKey(), selected); else sessionStorage.removeItem(storageKey()); } catch (error) {}
    mount(document, true);
    document.dispatchEvent(new CustomEvent('lp:reader-mood', {detail: {id: selected, mood: choice()}}));
  }
  function orderedProducts() {
    const mood = choice();
    const excluded = new Set((options.excludedIds ? options.excludedIds() : []).map(String));
    const candidates = options.products.filter(product => product.available !== false && !excluded.has(String(product.id)));
    const preferred = mood ? mood.productHandles : options.defaultHandles;
    return candidates.map((product, index) => {
      const match = preferred.indexOf(handleOf(product));
      return {product, score: match >= 0 ? 1000 - match : mood && mood.categoryHandles.includes(product.category) ? 100 : 0, index};
    }).sort((a,b) => b.score - a.score || a.index - b.index).slice(0, options.limit || 4).map(row => row.product);
  }
  function mount(scope, announce) {
    if (!options) return;
    for (const shelf of scope.querySelectorAll('[data-reader-shelf]')) {
      const controls = shelf.querySelector('[data-reader-mood-controls]');
      const heading = shelf.querySelector('[data-reader-shelf-heading]');
      const status = shelf.querySelector('[data-reader-mood-status]');
      const grid = shelf.querySelector('[data-reader-shelf-grid]');
      const mood = choice();
      if (controls && !controls.children.length) {
        controls.innerHTML = '<button type="button" data-reader-mood="" aria-pressed="false">All favorites</button>' + options.data.moods.map(item => '<button type="button" data-reader-mood="' + esc(item.id) + '" aria-pressed="false">' + esc(item.label) + '</button>').join('');
      }
      if (controls) for (const button of controls.querySelectorAll('[data-reader-mood]')) button.setAttribute('aria-pressed', String((button.dataset.readerMood || null) === selected));
      if (heading) heading.textContent = mood ? mood.shelfHeading : options.data.selector.defaultShelfHeading;
      if (status) status.textContent = mood ? mood.line : '';
      if (grid) grid.innerHTML = orderedProducts().map(options.renderCard).join('');
      const live = shelf.querySelector('[data-reader-announcement]');
      if (live && announce) live.textContent = mood ? options.data.selector.selectionAnnouncement.replace('{label}',mood.label) : options.data.selector.resetAnnouncement;
    }
    revealCategory(scope);
    mountCatalogNavigation();
    revealLinkedShelf(scope);
  }
  function revealCategory(scope) {
    for (const rail of scope.querySelectorAll('.category-list')) {
      const active = rail.querySelector('[aria-current="page"]');
      if (!active || rail.scrollWidth <= rail.clientWidth) continue;
      const left = active.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - (rail.clientWidth - active.getBoundingClientRect().width) / 2;
      rail.scrollTo({left: Math.max(0,left), behavior: 'instant'});
    }
  }
  // Browse visibility never changes product eligibility, category facts, or mood data.
  function browseCategories(catalog) {
    const groups = new Map();
    for (const product of catalog || (options && options.products) || []) {
      if (!product.category || product.category === 'book-lovers') continue;
      const group = groups.get(product.category) || {handle: product.category, name: product.categoryName || product.category, count: 0};
      group.count += 1;
      groups.set(product.category, group);
    }
    return Array.from(groups.values()).filter(group => group.count >= 4);
  }
  function canBrowseCategory(handle, catalog) {
    return browseCategories(catalog).some(group => group.handle === handle);
  }
  function diverseProducts(ranked, limit, perCategory) {
    const result = [], seen = new Set(), counts = new Map();
    const maximum = perCategory || 2;
    for (const product of ranked) {
      const id = String(product.id), category = product.category || '';
      if (seen.has(id) || (counts.get(category) || 0) >= maximum) continue;
      result.push(product); seen.add(id); counts.set(category, (counts.get(category) || 0) + 1);
      if (result.length >= limit) return result;
    }
    for (const product of ranked) {
      if (seen.has(String(product.id))) continue;
      result.push(product); seen.add(String(product.id));
      if (result.length >= limit) break;
    }
    return result;
  }
  function descriptionParts(html, included) {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    const intro = doc.querySelector('p');
    const introText = intro ? intro.textContent.trim() : '';
    if (intro) intro.remove();
    const normalize = value => String(value || '').toLowerCase().replace(/[\s\u00a0]+/g, ' ').replace(/[.,;:!?]+/g, '').trim();
    const includedText = normalize(included), seen = new Set();
    for (const node of doc.body.querySelectorAll('p, li')) {
      const value = normalize(node.textContent);
      // Exact/contained repeated statements only; never discard unique dimensions or care facts.
      if ((value.length >= 12 && includedText.includes(value)) || (value && seen.has(value))) node.remove();
      else if (value) seen.add(value);
    }
    for (const list of doc.body.querySelectorAll('ul, ol')) if (!list.querySelector('li')) list.remove();
    const hasDetails = !!doc.body.textContent.trim() || !!doc.body.querySelector('img, video, table');
    return {intro: introText, details: hasDetails ? doc.body.innerHTML.trim() : ''};
  }
  let catalogHeaderObserver = null, observedCatalogHeader = null, catalogResizeFallback = null, linkedShelfRevealed = false;
  function mountCatalogNavigation() {
    if (!document.documentElement || !document.querySelector) return;
    const header = document.querySelector('body > header');
    document.documentElement.classList.toggle('has-sticky-catalog', !!document.querySelector('.catalog-nav-sticky'));
    if (!header) return;
    const update = () => document.documentElement.style.setProperty('--lp-sticky-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    update();
    if (observedCatalogHeader === header) return;
    if (catalogHeaderObserver) catalogHeaderObserver.disconnect();
    if (catalogResizeFallback) window.removeEventListener('resize', catalogResizeFallback);
    observedCatalogHeader = header;
    if (typeof ResizeObserver !== 'undefined') {
      catalogHeaderObserver = new ResizeObserver(update);
      catalogHeaderObserver.observe(header);
    } else if (window.addEventListener) {
      catalogResizeFallback = update;
      window.addEventListener('resize', update, {passive: true});
    }
  }
  function revealLinkedShelf(scope) {
    if (linkedShelfRevealed || !window.location || window.location.hash !== '#reader-shelf-title') return;
    const shelf = scope.querySelector && scope.querySelector('[data-reader-shelf]');
    if (!shelf) return;
    linkedShelfRevealed = true;
    shelf.scrollIntoView({block: 'start', behavior: 'instant'});
  }
  function continuationCategories(active, catalog) {
    const groups = browseCategories(catalog).filter(group => group.handle !== active);
    return groups.sort((a, b) => {
      const ai = primary.indexOf(a.handle), bi = primary.indexOf(b.handle);
      return (ai < 0 ? primary.length : ai) - (bi < 0 ? primary.length : bi) || a.name.localeCompare(b.name);
    }).slice(0, 4);
  }
  function renderChapters(config) {
    const cards = primary.filter(category => canBrowseCategory(category, config.products)).map(category => {
      const photos = config.products.filter(product => product.category === category && product.available !== false && imageOf(product)).slice(0,3);
      if (!photos.length) return '';
      const media = photos.map(product => '<img src="' + esc(config.imageUrl ? config.imageUrl(imageOf(product),500) : imageOf(product)) + '" alt="' + esc(product.title) + '" loading="lazy">').join('');
      return '<a class="category-tile chapter-tile" href="' + esc(config.collectionUrl(category)) + '"><div class="category-collage" data-count="' + photos.length + '">' + media + '</div><h3>' + (config.icon ? config.icon(category) : '') + esc(titles[category]) + '</h3></a>';
    }).join('');
    return '<section class="wrap category-section" aria-labelledby="chapters-title"><div class="chapter-heading"><div><p class="eyebrow">Made for your kind of reader</p><h2 id="chapters-title">Choose your chapter.</h2></div><a href="' + esc(config.allUrl) + '">Explore all</a></div><div class="category-cards chapter-rail">' + cards + '</div></section>';
  }
  function renderShelf(config) {
    return '<section class="wrap favorites reader-shelf" data-reader-shelf aria-labelledby="reader-shelf-title"><div class="section-heading"><div><p class="eyebrow">Your reading life</p><h2 id="reader-shelf-title" data-reader-shelf-heading>Little things for a life with books</h2></div><a href="' + esc(config.allUrl) + '">Explore all</a></div><div class="reader-mood-controls" data-reader-mood-controls aria-label="Choose your reading mood"></div><p class="reader-mood-status" data-reader-mood-status></p><span class="visually-hidden" data-reader-announcement role="status" aria-live="polite"></span><div class="grid" data-reader-shelf-grid></div></section>';
  }
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-reader-mood]');
    if (!button || !button.closest('[data-reader-mood-controls]') || !options) return;
    setChoice(button.dataset.readerMood || null);
  });
  window.ReaderEditorial = {
    init: function (config) {
      options = Object.assign({defaultHandles: ['cant-leave-my-book-keychain','pink-bow-zip-book-sleeve','colorful-book-stack-earrings','easily-distracted-by-books-cup'],limit:4},config);
      try { const saved = sessionStorage.getItem(storageKey()); selected = options.data.moods.some(mood => mood.id === saved) ? saved : null; } catch (error) { selected = null; }
      mount(document,false);
    },
    mount: function (scope) { mount(scope || document,false); },
    getChoice: choice,
    affinity: function (product) { const mood = choice(); return !mood ? 0 : mood.productHandles.includes(handleOf(product)) ? 2 : mood.categoryHandles.includes(product.category) ? 1 : 0; },
    mountCatalogNavigation,
    continuationCategories,
    browseCategories,
    canBrowseCategory,
    diverseProducts,
    descriptionParts,
    renderChapters,
    renderShelf,
    revealCategory: function (scope) { revealCategory(scope || document); }
  };
})();
